// components/ArticleList.tsx
import React from 'react';
import { EstadoBeseifCompra } from '@/objects/Beseif';
import { useTranslation } from 'react-i18next';
import Texto from '@/components/elements/Texto';
import { textosMini } from '@/constants/Dimens';
import { black, lightGray } from '@/constants/Colors';
import { dateToTextTForm, obtenerHoraTForm } from '@/util/MagicDate';

interface Props {
  estadoBeseifCompra: EstadoBeseifCompra[];
}

const EstadoCompra: React.FC<Props> = ({ estadoBeseifCompra }) => {

  const { t } = useTranslation();

  const estadosOrdenados = [...estadoBeseifCompra].sort((a, b) => {
    return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
  });


  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: "100%", gap: "10px" }}>
      {estadosOrdenados.map((estado, index) => {
        const esActual = index === 0;

        return (
          <section
            key={`${estado.id}-${index}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: "100%",
              borderLeft: esActual ? '3px solid #1a73e8' : '3px solid #d9d9d9',
              paddingLeft: '10px',
              gap: '4px',
            }}
          >
            <Texto color={esActual ? black : lightGray}>
              {t(`menu:secciones.mis_compras.seguimiento.estados.${estado.accion}`)}
            </Texto>

            <Texto fontSize={textosMini} color={esActual ? black : lightGray} html={true}>
              {t(`menu:secciones.mis_compras.seguimiento.descripciones.${estado.accion}`)}
            </Texto>
            {estado.fecha_recogida &&
              <Texto fontSize={textosMini} color={esActual ? black : lightGray}>
                {t("menu:secciones.mis_compras.seguimiento.fecha_maxima_envio_descripcion", { fecha: estado.fecha_recogida })}
              </Texto>
            }
            <Texto fontSize={textosMini} color={lightGray}>
              {dateToTextTForm(estado.timestamp, t) + " " + obtenerHoraTForm(estado.timestamp)}
            </Texto>
          </section>
        );
      })}
    </div>
  );
}

export default EstadoCompra;

